<template>
    <div class="container">
        <div class="topBg">
            <mt-swipe ref="swipe" :auto="0" @change="handleChange" :show-indicators="false" >
                <mt-swipe-item v-for="(item,index) in biaoList" :key="index">
                    <div class="swiper_bg">
                        <div class="swiper_top">
                            <div class="swiper_top_item1">
                                <span class="swiper_top_span1">仪表号</span>
                                <span class="swiper_top_span2">{{item.meterNo}}</span>
                            </div>
                            <div class="swiper_top_item2">
                                <span class="swiper_top_span1">仪表名</span>
                                <span class="swiper_top_span2">{{item.name}}</span>
                            </div>
                            <span class="swiper_top_span3">{{index+1}}/{{biaoList.length}}</span>
                        </div>
                        <div class="swiper_footer">
                            <span class="swiper_top_span4">{{item.merchantName}}</span>
                            <span class="swiper_top_span5">{{item.storeNo}}</span>
                        </div>

                    </div>
                </mt-swipe-item>
            </mt-swipe>
            <img @click="changeSwipeIndex(-1)" class="prevIcon"
                    src='../../assets/images/btn_coupon_last@2x.png'/>
            <img @click="changeSwipeIndex(1)" class="nextIcon"
                    src='../../assets/images/btn_coupon_next@2x.png'/>
        </div>
        <div class="yuerBg">
            <span class="yuer_span1">余额</span>
            <div class="yuer_div" >
                <span class="yuer_span2">{{syAmount}}</span>
                <span class="yuer_span3">元</span>
            </div>
             <span class="yuerTime_span">余额更新时间:{{meterRefreshTime}}</span>
             <img class="yuer_Icon" @click="getYuer()"
                    src='../../assets/images/btn_refresh@2x.png'/>
        </div>
        <div class="body">
            <div class="bodyItem">
                <div class="bodyItem_left">
                    <span class="bodyItem_span">充值金额(元)</span>
                </div>
                <div class="bodyItem_right">
                   <input class="inp_amount" type="number" maxlength="9" @input="oninput"
                   v-model="amount" placeholder="请输入金额">
                </div>
            </div>
            <div class="bodyItem1">
                <span @click="toRecharge" :class="[amount?'body_button1':'body_button2']">立即充值</span>
            </div>

        </div>
        <div class="listView">
            <div class="listItem" @click="toRecord">
                <span class="listItem_span">充值记录</span>
                <img class="listItem_icon" src="../../assets/images/icon_indicator_next.png"/>
            </div>
            <div class="listLine"></div>
             <div class="listItem" @click="toUseStatistics">
                <span class="listItem_span">用电统计</span>
                <img class="listItem_icon" src="../../assets/images/icon_indicator_next.png"/>
            </div>
        </div>
    </div>
</template>

<script>
import util from "../../utils/util";
import storage from '../../utils/storage';
import ping from '../../utils/pingpay.js'
import { mapState,mapActions } from "vuex";
import {callSpaceUp,insertRechargeOrder} from "../../utils/api";
export default {
  components: {  },
  name: "hpRecharge",
  data() {
    return {

       timeout:'',//定时器
       biaoList:[],
       syAmount:0,
       meterRefreshTime:'',
       amount:'',
       swipeIndex:0,
       selectIntelligence:'',
       intelligenceCode:'' , //表号
       storeNo:'', //单元号
       orderNo:'',
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
     this.getDeviceList();
     //this.insertRechargeOrder()
  },
  methods: {
        ...mapActions(['getMarketInfo','getUserInfo','getTenantInfo','getTenantInfoList','getTheme','getHolidayStyle']),
        handleChange(index){
            this.swipeIndex =index
            clearTimeout(this.timeout) //防止连续滚动触发
            this.timeout = setTimeout(() => {
                 this.swipeIndex =index
                 console.log("handleChangeIndex ===  "  + index)
                 this.intelligenceCode =this.biaoList[index].id
                 this.storeNo = this.biaoList[index].storeNo
                 this.selectIntelligence =this.biaoList[index]
                 this.getYuer();
            }, 500)
        },
        changeSwipeIndex(index){
            // console.log("changeSwipeIndex ===  "  + this.$refs.swipe.index)
            // var swipeIndex = this.$refs.swipe.index; //轮播当前索引
            if (index==1) {
                //if(this.swipeIndex<this.biaoList.length){
                    this.$refs.swipe.next(); // 转到下一张轮播图
                //}
                // this.swipeIndex=this.$refs.swipe.index
            } else if (index==-1) {
               // if(this.swipeIndex>0){
                    this.$refs.swipe.prev(); // 转到前一张轮播图
                //}
                //  this.swipeIndex=this.$refs.swipe.index
            }
            console.log("hpRecharge    === " +  this.swipeIndex)
        },
        //huo
        getDeviceList() {
            var params = {
                userId: this.common.userId,
                marketId: this.common.marketInfo.id,
                subProjectIds:this.common.marketInfo.id,
                companyId: this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                page:1,
                pageSize:100,
                spaceName:'',
                platform: "RST",
                merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
                url: "/property/rstRepair/queryDeviceMonitorPage"
            }
            callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                   var list =res.body.data.list
                    for(var i=0;i<list.length;i++){
                        var item =list[i];
                        var pitem  =item.prpDeviceSpaceRelBeans
                        if(pitem && pitem.length>0){
                            item.storeNo = pitem[0].subProjectName +'-'+pitem[0].buildName+"-"+pitem[0].spaceName
                        }
                    }
                    this.biaoList =list;
                    if(list.length>0){
                        this.intelligenceCode =list[0].id
                        this.storeNo = list[0].storeNo
                        this.selectIntelligence =this.biaoList[0]
                        this.getYuer()
                    }else{
                        util.showToast("没有相关电表数据")
                    }
                }
            });
        },
        //获取表余额
        getYuer(){
             var params = {
                deviceId:this.intelligenceCode,
                //  deviceId:1717,
                 marketId: this.common.marketInfo.id,
                 companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                 merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
                // url:"/property/rstRepair/loadPrpDeviceById"
                 url:"/property/rstRepair/refreshMeterLeftMoneyInfo"
             }
              callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                    var obj =res.body.data
                    //this.syAmount = obj.balance ||0
                    this.syAmount = obj.meterLeftMoney ||0
                    this.meterRefreshTime = obj.meterRefreshTime
                }
            });
        },
        //生成订单
        toRecharge(){
            if(!this.amount){
                return
            }
            if(!this.intelligenceCode){
                util.showToast("没有可以充值的电表")
                return
            }
            var params = {
                userId: this.common.userId,
                marketId: this.common.marketInfo.id,
                companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                deviceId:this.intelligenceCode, //1731
                platform: "RST",
                merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
                url: "/property/rstRepair/checkMeterCanRemoteCharge"
            }
            var that=this
            var msg ="确定要为表"+that.selectIntelligence.name +"充值"+that.amount+"元吗?"
            util.showModal('',msg,true,'确定',()=>{
                            that.insertRechargeOrder();
            })
            // callSpaceUp(params).then(res => { //检查是否可以充值
            //     if (res.res.code == 10000) {
            //          var msg ="确定要为表"+that.selectIntelligence.name +"充值"+that.amount+"元吗?"
            //             util.showModal('',msg,true,'确定',()=>{
            //                 that.insertRechargeOrder();
            //         })
            //     }else{
            //         util.showToast(res.res.msg)
            //     }
            // });


        },

        insertRechargeOrder(){
            let params = {
                userId: this.common.userId,
                userName: this.common.userTenantInfo.userName ||this.common.userInfo.userName ||this.common.userInfo.name ,
                cityId:  String(this.common.marketInfo.cityId) , //'20',//
                marketId: this.common.marketInfo.id,
                companyId: String( this.common.userTenantInfo.companyId),// '44',
                phone:this.common.userTenantInfo.phone ,
                rechargeType: 2, //2是电费,1是水费
                rechargeAmount: parseFloat(this.amount),
                // unitPrice: parseFloat(this.data.unitPrice),
                // kwh: parseFloat(kwh), //this.data.dushu
                storeNo: this.storeNo,
                intelligenceCode: String(this.intelligenceCode) ,
            };
            // console.log("params == "  +JSON.stringify(params))
            insertRechargeOrder(params).then(res => {
                if (res.res.code == 10000) {
                    this.orderNo=res.body.orderNo;
                    this.pingPay();
                }
            });

        },

        oninput(e) {
            // 通过正则过滤小数点后两位
            e.target.value = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null
            console.log('e',e.target.value)
            this.amount = e.target.value
        },
        toRecord(){
            // id=${item.id}`
             this.$router.push('/rechargeRecord');
        },
        toUseStatistics(){
             this.$router.push('/hpuseStatistics');
        },


        pingPay() {
            let self = this;
            let params = {
                orderNo: this.orderNo,
                repairNo: '', // "报修单号",
                bussinessType: "8", //水电充值
                payType: "", //
                feeCode: "",
                channel: 'wx_pub' // 渠道名
            };
            ping(params,
                '',
                res => {
                    self.paySuccess();
                }, () => {
                    util.showToast("支付失败");
                }, () => {
                    util.showToast("支付取消");
            })
        },
        paySuccess(){
            console.log("支付成功") //刷新余额数据
            this.getYuer();

        },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  min-height: 100vh;
  background: #F3F4F6;
  flex-direction: column;
}
.topBg{
    flex-direction: column;
    position: relative;
    width: 750px;
    height: 322px;
    background: #FFFFFF;
}

//轮播图
.swiper_bg{
    margin-top: 28px;
    margin-left: 28px;
    margin-right: 28px;
    width: 694px;
    height: 266px;
    background: linear-gradient(270deg, #FFBE00 0%, #FFA100 100%);
    box-shadow: 0px 8px 24px 0px #FFEAC8;
    border-radius: 12px;
    flex-direction: column;
}
.swiper_top{
    width: 694px;
    display: flex;
    height: 136px;
    flex-direction: column;
    position: relative;
}
.swiper_top_item1{
    width: 694px;
    display: flex;
    height: 40px;
    margin-top: 28px;
    flex-direction: row;
}
.swiper_top_item2{
    width: 694px;
    height: 40px;
    display: flex;
    margin-top: 8px;
    flex-direction: row;
}
.swiper_top_span1{
    margin-left: 28px;
    width: 100px;
    display: flex;
    height: 40px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
}
.swiper_top_span2{
    width: 452px;
    height: 40px;
    display: flex;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
}
.swiper_top_span3{
    position: absolute;
    right: 28px;
    top:28px;
    height: 32px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 32px;
}
.swiper_footer{
    width: 694px;
    height: 130px;
    background: rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
}
.swiper_top_span4{
     width: 638px;
    margin-top: 20px;
    margin-left: 28px;
    height: 34px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 34px;
}
.swiper_top_span5{
     margin-top: 8px;
    margin-left: 28px;
    width: 638px;
    height: 40px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
}
// 箭头。
.prevIcon{
    position: absolute;
    left: 20px;
    top: 140px;
    width: 44px;
    height: 44px;
    display: block;

}
.nextIcon{
    position: absolute;
    right: 20px;
    top: 140px;
    width: 44px;
    height: 44px;
    display: block;
}

// yuerBg
.yuerBg{
    margin-top: 14px;
    width: 750px;
    height: 220px;
    display: flex;
    position: relative;
    background: #FFFFFF;
    flex-direction: column;
}
.yuer_span1{
    margin-top: 28px;
    width: 750px;
    text-align: center;
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
}
.yuer_div{
    margin-top: 4px;
    width: 750px;
    flex-direction: row;
    display: flex;
    justify-content: center;

}
.yuerTime_span{
    margin-top: 4px;
    width: 750px;
    text-align: center;
    flex-direction: row;
     font-size: 20px;
     color: #999999;
}
.yuer_span2{
    height: 84px;
    font-size: 60px;
    font-weight: 400;
    color: #333333;
    line-height: 84px;
}
.yuer_span3{
    margin-left: 8px;
    margin-top: 28px;
    height: 44px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height: 44px;
}
.yuer_Icon{
    position: absolute;
    width: 44px;
    height: 44px;
    top: 28px;
    right: 28px;
}

//body
.body{
    width: 750px;
    height: 256px;
    background: #FFFFFF;
    flex-direction: column;
    display: flex;
}
.bodyItem{
    width: 750px;
    height: 100px;
    background: #FFFFFF;
    display: flex;
    flex-direction: row;
}
.bodyItem_left{
    width: 258px;
    height: 100px;
    flex-direction: row;
    display: flex;
}
.bodyItem_span{
    margin-left: 40px;
    height: 100px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height: 100px;
}
.bodyItem_right{
    width: 492px;
    height: 100px;
    flex-direction: row;
    display: flex;
    border-bottom: 2px solid #eaeaea;
}
.inp_amount{
    width: 470px;
    height: 100px;
    font-size: 32px;
    font-weight: 400;
    color: #666666;
    line-height: 100px;
}
.bodyItem1{
    width: 750px;
    height: 156px;
    flex-direction: column;
    display: flex;
}
.body_button1{
    margin-top: 40px;
    margin-left: 28px;
    width: 694px;
    height: 88px;
    background: #0087ff;
    border-radius: 4px;
    text-align: center;
    font-size: 34px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 88px;
}

.body_button2{
    margin-top: 40px;
    margin-left: 28px;
    width: 694px;
    height: 88px;
    background: #DADADA;
    border-radius: 4px;
    text-align: center;
    font-size: 34px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 88px;
}
.listView{
    flex-direction: column;
    margin-top: 14px;
    width: 750px;
}
.listItem{
    flex-direction: row;
    width: 750px;
    display: flex;
    height: 100px;
    background: #FFFFFF;
    justify-content: space-between;
    align-items: center;
}
.listLine{
    display: flex;
    margin-left: 28px;
    width: 722px;
    height: 2px;
    background: #EAEAEA;
}
.listItem_span{
    height: 44px;
    margin-left: 28px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height:44px;
}
.listItem_icon{
    margin-right: 28px;
    width: 32px;
    height: 32px;
    // margin-top: 28px;
    // background-color: seagreen;
}


</style>